// @flow

export const TYPE = {
  BINARY: 'application/octet-stream',
  GIF: 'image/gif',
  JPEG: 'image/jpeg',
  PNG: 'image/png',
  TEXT: 'text/plain'
};

export type FileContentType =
  | typeof TYPE.BINARY
  | typeof TYPE.GIF
  | typeof TYPE.JPEG
  | typeof TYPE.PNG
  | typeof TYPE.TEXT
  | string;

export type File = {
  ETag?: string,
  MD5Hash?: string,
  color?: string,
  contentType?: FileContentType,
  copyOf?: string,
  createdBy: string,
  createdDate: string,
  displaySize?: string,
  downloadUrl?: string,
  extractedFiles?: Array<string>,
  fileID: string,
  fileName: string,
  filePath?: string,
  icon?: string,
  isPublic?: string,
  isUploaded?: boolean,
  meassageID?: string,
  nextVersion?: string,
  originalFile?: string,
  previousVersion?: string,
  processID?: string,
  processName?: string,
  runID?: string,
  serverSideEncryption?: string,
  size?: string,
  stepName?: string,
  tableID?: string,
  tags?: Array<string>,
  taskName?: string,
  teamName: string,
  threadID?: string,
  thumbnails?: Array<string>,
  uploadUrl?: string,
  versions?: Array<string>
};

export type FileReference = string;



// WEBPACK FOOTER //
// ./js/File/FileType.js